import { Box, Stack } from "@mui/material";
import Inspection from "./Inspection";
import { useOrderContext } from "context/OrderContext";
import EmptyMessage from "components/EmptyMessage";

const Inspections = () => {
  const order = useOrderContext();
  const approvals = order.customerApprovals;

  return (
    <Box p={1}>
      {!!order.parentOrderNumber ? (
        <EmptyMessage m={1}>Denna order rapporteras på huvudordern</EmptyMessage>
      ) : !approvals.length ? (
        <EmptyMessage m={1}>Inga besiktningar utförda på denna order</EmptyMessage>
      ) : (
        <Stack spacing={1}>
          {approvals.map((approval) => (
            <Inspection key={approval.id} approval={approval} />
          ))}
        </Stack>
      )}
    </Box>
  );
};

export default Inspections;
